import React from "react";

import { format, isValid, parseISO } from "date-fns";
import { useTranslate } from "localization";

interface DateProps {
  value?: string | Date;
  emptyText?: string;
  formatString?: string;
  italic?: boolean;
}

const Date: React.FC<DateProps> = ({
  value,
  emptyText,
  formatString,
  italic,
}) => {
  const { translate } = useTranslate();

  if (!value) {
    return <>{emptyText ?? translate("blank")}</>;
  }

  const parsed = typeof value === "string" ? parseISO(value) : value;
  if (!isValid(parsed)) {
    return <>{emptyText ?? translate("blank")}</>;
  }

  if (italic) {
    return <i>{format(parsed, formatString ?? translate("dateFormat"))}</i>;
  }

  return <>{format(parsed, formatString ?? translate("dateFormat"))}</>;
};

export default React.memo(Date);
